import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { elements } from "constants/types";
import Spinner from "@visiblethread/react-components/dist/components/Spinner";

const SpinnerWithLoadMask = ({ opacity, fullScreen }) => {
  const jobQueue = useSelector((state) => state.app.jobQueue);
  const jobQueueEmpty = !jobQueue || jobQueue.length === 0;
  const discoveryConfigLoading = useSelector(
    (state) => state.discovery.config.loading
  );
  const dictSearchConfigLoading = useSelector(
    (state) => state.dictionarySearch?.config.loading
  );

  const showMask =
    (!jobQueueEmpty && fullScreen) ||
    (discoveryConfigLoading?.find((load) => load.element === elements.CONTENT)
      ?.loading &&
      !fullScreen) ||
    (dictSearchConfigLoading?.find((load) => load.element === elements.CONTENT)
      ?.loading &&
      !fullScreen);

  return (
    showMask && (
      <Spinner
        opacity={opacity}
        fullScreen={fullScreen}
        size={fullScreen ? "62px" : ""}
      />
    )
  );
};

export default SpinnerWithLoadMask;

SpinnerWithLoadMask.propTypes = {
  opacity: PropTypes.number.isRequired,
  fullScreen: PropTypes.bool.isRequired,
};
